module.exports = __webpack_public_path__ + "media/img/logos/ubs-08c7154991d90bf101f015705a0b3de7.svg";